export default __webpack_public_path__ + "static/media/materials.db31c0b4.svg";